import ef from 'ef/ef';

var AssessmentService = {
  initialize: function(assessmentMap){
    assessmentMap = (assessmentMap || {});
    this.mapping = assessmentMap;
    this.ContentProvider = require('services/content-provider');
  },

  getAssessment: function(courseSlug){
    var slug;
    try{
      slug = ef.options.local ? courseSlug : this.getAssessmentActivity(courseSlug).slug;
    } catch(e) {
      slug = courseSlug;
    }
    return new ef.Models.Assessments.Assessment({slug: slug});
  },

  getUrl: function(courseSlug){
    var activity = this.getAssessmentActivity(courseSlug);
    var redirectPath = window.location.pathname + "#" + ef.module.currentActivity.currentPage.path() + '?assessmentTaken=true';
    var url = "/assessments/attempts/:assessment_slug?redirect_url=:redirect_url";
    url = url.replace(':assessment_slug', activity.slug);
    url = url.replace(':redirect_url', encodeURIComponent(redirectPath));
    return url;
  },

  getBestScore: function(courseSlug){
    return this.ContentProvider.AssessmentService.getBestScore(courseSlug);
  },

  getAssessmentStatus: function(courseSlug){
    var attempts = this.getActivityProgressForSlug(courseSlug, true);
    if (attempts.length === 0) {
      return 'not-attempted';
    } else if (_.every(attempts, function (ap) { return !ap.get('passed'); })) {
      return 'failed';
    } else if (_.some(attempts, function (ap) { return ap.get('passed'); })) {
      return 'passed';
    }
  },

  getAssessmentActivity: function(courseSlug){
    var activity = this.mapping[courseSlug];
    if(activity){
      return activity;
    } else {
      console.warn("Invalid assessment mapping for slug: ", courseSlug);
      console.warn("Here are the configured assessment mappings for reference: ", this.mapping);
      // trigger something special...
    }
  },

  userHasCompletedAssessment: function(courseSlug){
    return this.ContentProvider.AssessmentService.userHasCompletedAssessment(courseSlug); 
  },

  getActivityProgressForSlug: function(courseSlug, includeFailed) {
    if (ef.options.local){
      return ef.activityProgresses.filter(function(ap) {
        return ap.get('slug') === courseSlug && (ap.get('passed') || includeFailed);
      });
    } else {
      var activity = this.getAssessmentActivity(courseSlug);
      return ef.activityProgresses.filter(function(ap){
        return ap.get('activity_id') === activity.id && (ap.get('passed') || includeFailed);
      });
    }
  }
};

module.exports = AssessmentService;
